import { Box, Typography } from "@mui/material";
import { ButtonCust, SimpleModal } from "../../../widgets";
import EnvConfig from "../../../../config/env.config.json";
import { brandNames } from "../../../../enums";
import { useAppSelector } from "../../../../app/hooks";
import { BrandNameUpdate } from "../../../../utils/commonFunctions/BrandNameUpdate";
import { shopWareRedirectionHandler } from "../../../../utils";

type Props = {
  modalFg: boolean;
  closeHandler?: any;
  content: any;
  imeiModel?: any;
  setImeiModel?: any;
  errModalMsg?: any;
  setErrModalMsg?: any;
  imeiErrorModal?: any;
  setImeiErrorModal?: any;
  isEsimAvailable?: any;
  setIsEsimAvailable?: any;
  isPsimAvailable?: any;
  setIsPsimAvailable?: any;
  setModalStatus?: any;
  formik?: any;
};

export function IMEIFailureModal(props: Props) {
  const {
    modalFg,
    closeHandler,
    content,
    imeiModel,
    setImeiModel,
    errModalMsg,
    setErrModalMsg,
    imeiErrorModal,
    setImeiErrorModal,
    setModalStatus,
    formik,
  } = props;
  const { title, desc, try_again, shop_btn_txt } = content?.imei_fail_md || {};
  const { globalVal } = useAppSelector(
    (state: any) => state?.strapi?.globalValues || {}
  );
  const getButtonType = () => {
    switch (EnvConfig.DOMAIN) {
      case brandNames.REACH:
        return EnvConfig.PRIMARY_BUTTON_TYPE;
      case brandNames.WOW:
        return "primary_contained_rounded";
      default:
        return EnvConfig.PRIMARY_BUTTON_TYPE;
    }
  };

  const tryAgainHandler = () => {
    setImeiErrorModal(false);
    setModalStatus(false);
  };
  return (
    <SimpleModal
      isShowModal={modalFg}
      onCloseModal={closeHandler}
      showClose={true}
      sx={{ width: { xs: "95%", sm: "60%", md: "55%", lg: "50%", xl: "45%" } }}
      style={{ borderRadius: "4px" }}
    >
      {imeiErrorModal ? (
        <Box sx={{ textAlign: "center", maxWidth: "600px" }}>
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Box
              component="img"
              alt={
                content?.imei_error_img?.data?.attributes?.alternativeText || ""
              }
              src={content?.imei_error_img?.data?.attributes?.url || ""}
              sx={{ display: "flex" }}
            />
          </Box>

          {imeiModel && (
            <Typography
              sx={{
                mt: "20px",
                fontSize: "18px",
                fontWeight: 400,
                textAlign: "center",
                fontFamily: "var(--font_family_Regular) !important",
                color: "var(--black)",
                "& strong": {
                  fontFamily: "var(--font_family_Bold) !important",
                  fontWeight: 700,
                },
              }}
              dangerouslySetInnerHTML={{
                __html: errModalMsg?.replace(
                  "{brandModel}",
                  `<strong>${imeiModel}</strong>`
                ),
              }}
            ></Typography>
          )}

          <ButtonCust
            variantType={EnvConfig.PRIMARY_BUTTON_TYPE}
            onClick={() => tryAgainHandler()}
            sx={{
              mt: "30px",
              mb: "10px",
              width: { xs: "fit-content", sm: "250px" },
            }}
          >
            {content?.imei_error_modal?.btnText1}
          </ButtonCust>
        </Box>
      ) : (
        <Box
          display="flex"
          flexDirection="column"
          p={1}
          pt={0.5}
          alignItems="center"
        >
          {content?.imei_fail_md?.cncl_icon && (
            <Box
              component="img"
              sx={{ marginBottom: "20px" }}
              alt={
                content?.imei_fail_md?.cncl_icon?.data?.attributes
                  .alternativeText || ""
              }
              src={content?.imei_fail_md?.cncl_icon?.data?.attributes.url || ""}
            />
          )}
          <Box
            sx={{
              fontSize: content?.imei_fail_md?.no_device_store
                ? "24px"
                : "22px",
              color: content?.imei_fail_md?.no_device_store
                ? "var(--black) "
                : "var(--text_color)",
              fontFamily: "var(--font_family_Bold)",
              fontWeight: "var(--font_weight_4)",
            }}
          >
            {title}
          </Box>
          <Box
            pt={2}
            sx={{
              marginBottom: content?.imei_fail_md?.no_device_store
                ? "16px"
                : "0px",
              fontSize: content?.imei_fail_md?.no_device_store
                ? "18px"
                : "14px",
              color: "var(--text_color)",
              textAlign: "center",
              fontFamily: "var(--font_family_Medium)",
              fontWeight: "var(--font_weight_1)",
            }}
          >
            {BrandNameUpdate(desc)}
          </Box>
          {content?.imei_fail_md?.no_device_store ? (
            <ButtonCust
              sx={{ padding: "22px" }}
              variantType={EnvConfig.PRIMARY_BUTTON_TYPE}
              onClick={closeHandler}
            >
              {try_again}
            </ButtonCust>
          ) : (
            <Box
              pt={1}
              sx={{
                fontSize: "14px",
                color: "var(--primary_color)",
                cursor: "pointer",
                fontWeight: "bold",
              }}
              onClick={closeHandler}
            >
              {try_again}
            </Box>
          )}
          {shop_btn_txt && (
            <Box pt={3}>
              <ButtonCust
                variantType={getButtonType()}
                onClick={() => {
                  if (EnvConfig.IS_SHOPWARE_ENABLED) {
                    shopWareRedirectionHandler(EnvConfig?.SHOP_DOMAIN, "home");
                  } else {
                    window.open(globalVal?.shopPhone, "_blank");
                  }
                }}
              >
                {shop_btn_txt}
              </ButtonCust>
            </Box>
          )}
        </Box>
      )}
    </SimpleModal>
  );
}
